<template>
  <!-- 收銀台 -->
  <div v-if="$store.state.user.isCheckoutCounterActive" class="cc-frame">
    <div class="cc-container">
      <h1 class="cc-title-main">
        <span class="import-amount fw_700"> {{ $t('Bao.checkout_counter_title1', { value: queryParams.base_amount, symbol: queryParams.base_symbol }) }} </span>
      </h1>
      <h2 class="cc-title-secondary">
        <span class="get-amount fw_700"> {{ $t('Bao.checkout_counter_title2', { value: queryParams.target_amount, symbol: queryParams.target_symbol }) }} </span>
      </h2>
      <div class="cc-qr-input-group">
        <input type="text" class="qr-input-control" readonly="" :value="queryParams.target_address">
        <button id="button-addon2" class="btn btn-copy-qr" type="button" @click="copyText(queryParams.target_address)">
          <img :src="$getThemeImagePath('icon-copy-2.png')" alt="">
        </button>
      </div>
      <div class="qr-pic-box">
        <qrcode-vue :value="queryParams.target_address" :size="100" />
      </div>
      <div class="countdown-text">
        {{ $t('Bao.checkout_counter_time') }}
        <span v-if="timeLeft > 0" class="countdown-time"> {{ formattedTime }} </span>
      </div>
      <div class="cc-note-frame">
        <h3 class="list-title">
          {{ $t('Bao.checkout_counter_conditions') }}
        </h3>
        <ol class="list-type-decimal ">
          <li>
            <span class="charge-amount fw_700" /> {{ $t('Bao.checkout_counter_conditions1', { value: queryParams.fee_amount, symbol: queryParams.base_symbol }) }}
          </li>
          <li>
            {{ $t('Bao.checkout_counter_conditions2_1') }}<span class="exchange-amount fw_700"> {{ queryParams.base_amount }} </span>{{ queryParams.base_symbol }}{{ $t('Bao.checkout_counter_conditions2_2') }}
          </li>
          <li>{{ $t('Bao.checkout_counter_conditions3', { protocol: queryParams.blockchain_protocol }) }} </li>
          <li>{{ $t('Bao.checkout_counter_conditions4') }}<span class="coin-main fw_700"> 1 </span>{{ queryParams.base_symbol }} =<span class="coin-secondary fw_700"> {{ queryParams.price }} </span>{{ queryParams.target_symbol }}</li>
          <li><span class="text-color-warning fw_700">{{ $t('Bao.checkout_counter_conditions5_1') }}</span>{{ $t('Bao.checkout_counter_conditions5_2') }}</li>
          <li>{{ $t('Bao.checkout_counter_conditions6') }}</li>
          <li>{{ $t('Bao.checkout_counter_conditions7') }}</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import { copyText } from '@/utils/tool'
import qrcodeVue from 'qrcode.vue'

function getQueryParams(url) {
  const params = new URLSearchParams(new URL(url).search)
  const result = {}
  for (const [key, value] of params.entries()) {
    result[key] = value
  }
  return result
}
export default {
  name: 'CheckoutCounter',
  components: {
    'qrcode-vue': qrcodeVue
  },
  data() {
    return {
      queryParams: {},
      expired_at: 0,
      timer: null,
      timeLeft: 0
    }
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60)
      const seconds = this.timeLeft % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    }
  },
  created() {
    this.queryParams = getQueryParams(window.location.href)
    const params = new URLSearchParams(window.location.search)
    this.expired_at = params.get('expired_at') / 1000
    const currentTimeStamp = Math.floor(Date.now() / 1000)
    this.timeLeft = Math.floor(this.expired_at - currentTimeStamp)
    this.$store.commit('SET_CHECKOUT_COUNTER_OPEN', true)
  },
  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    copyText(msg) {
      copyText(msg, this.promotion_url)
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    }
  }
}
</script>
